var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0","height":"100%","width":"100%"}},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"ybp1"},on:{"mouseenter":_vm.clearDispatchTimer,"mouseleave":_vm.setDispatchTimer}})])
}
var staticRenderFns = []

export { render, staticRenderFns }